import {
  Flex, Grid, GridItem, Icon, IconButton, Text,
} from "@chakra-ui/react";
import { MdEdit, MdDelete } from "react-icons/md";
import { FaFolderPlus } from "react-icons/fa";
import { FcFolder } from "react-icons/fc";
import Helper from "../../../utils/Helper";

export default function Folder({ Item, OnChange, OnSelect, texts = {} }) { 
  const fileManagerTexts = texts?.fileManager || {};
  
  return (
    <Grid 
      templateColumns={"repeat(12, 1fr)"} 
      gap={2}
      alignItems="center" 
      w="100%" 
      py={2}
      borderRadius="md" 
      cursor="pointer"
      onDoubleClick={() => OnSelect(Item)}
      sx={{
        _hover: { 
          bg: 'var(--fm-item-hover-bg)' 
        }
      }}
    >
      <GridItem colSpan={{ base: 12, md: 5 }} as={Flex} alignItems="center">
        <Icon as={FcFolder} boxSize="1.5rem" mr={3} />
        <Text noOfLines={1} fontSize="sm">{Item.FolderName}</Text>
      </GridItem>
      
      <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
        <Text fontSize="xs" sx={{ color: 'var(--fm-item-meta-text)' }}>-</Text>
      </GridItem>
      
      <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
        <Text fontSize="xs" sx={{ color: 'var(--fm-item-meta-text)' }}>
          {Helper.HandleChatDate(Item.FolderUpdatedAt || Item.FolderCreatedAt)}
        </Text>
      </GridItem>

      <GridItem as={Flex} colSpan={{ base: 12, md: 3 }} justify="end" gap={1}>
        <IconButton 
          size="sm" 
          variant="ghost" 
          icon={<MdEdit />} 
          aria-label={fileManagerTexts.ariaLabels?.renameFolder || "Rename folder"}
          onClick={(e) => { e.stopPropagation(); OnChange({ Tab: "Edit", FolderId: Item.FolderId, FolderName: Item.FolderName, IsOpen: true }); }}
          sx={{
            color: 'var(--fm-item-icon-btn-color)',
            _hover: { color: 'var(--fm-item-icon-btn-hover-color)' }
          }}
        />
        <IconButton 
          size="sm" 
          variant="ghost" 
          icon={<MdDelete />} 
          aria-label={fileManagerTexts.ariaLabels?.deleteFolder || "Delete folder"}
          onClick={(e) => { e.stopPropagation(); OnChange({ Tab: "Delete", FolderId: Item.FolderId, IsOpen: true }); }}
          sx={{
            color: 'var(--fm-item-icon-btn-danger-color)',
            bg: 'var(--fm-item-icon-btn-hover-color)',
            _hover: { 
              color: 'var(--fm-item-icon-btn-danger-hover-color)', 
              bg: 'var(--fm-item-icon-btn-danger-hover-bg)' 
            }
          }}
        />
        <IconButton 
          size="sm" 
          variant="ghost" 
          icon={<FaFolderPlus />} 
          aria-label={fileManagerTexts.ariaLabels?.addSubfolder || "Add subfolder"}
          onClick={(e) => { e.stopPropagation(); OnChange({ Tab: "Create", ParentId: Item.FolderId, IsOpen: true }); }}
          sx={{
            color: 'var(--fm-item-icon-btn-color)',
            _hover: { color: 'var(--fm-item-icon-btn-hover-color)' }
          }}
        />
      </GridItem>
    </Grid>
  );
}